import AsyncLucideIcon from './LucideIcon/LucideIcon.async';
import { LucideType } from './LucideIcon/type';
import { MaterialVariant } from './MaterialIcon/constants';
import AsyncMaterialIconFilled from './MaterialIcon/Filled/MaterialIconFilled.async';
import AsyncMaterialIconOutlined from './MaterialIcon/Outlined/MaterialIconOutlined.async';
import AsyncMaterialIconRounded from './MaterialIcon/Rounded/MaterialIconRounded.async';
import AsyncMaterialIconSharp from './MaterialIcon/Sharp/MaterialIconSharp.async';
import AsyncMaterialIconTwoTone from './MaterialIcon/TwoTone/MaterialIconTwoTone.async';
import AsyncPhosphorIconBold from './PhosphorIcon/bold/PhosphorIconBold.async';
import { PhosphorVariant } from './PhosphorIcon/constants';
import AsyncPhosphorIconDuotone from './PhosphorIcon/duotone/PhosphorIconDuotone.async';
import AsyncPhosphorIconFill from './PhosphorIcon/fill/PhosphorIconFill.async';
import AsyncPhosphorIconLight from './PhosphorIcon/light/PhosphorIconLight.async';
import AsyncPhosphorIconRegular from './PhosphorIcon/regular/PhosphorIconRegular.async';
import AsyncPhosphorIconThin from './PhosphorIcon/thin/PhosphorIconThin.async';
import AsyncRemixIcon from './RemixIcon/RemixIcon.async';
import { RemixType } from './RemixIcon/type';
import AsyncSolarIconBoldDuotone from './SolarIcon/bold-duotone/SolarIconBoldDuotone.async';
import AsyncSolarIconBold from './SolarIcon/bold/SolarIconBold.async';
import AsyncSolarIconBroken from './SolarIcon/broken/SolarIconBroken.async';
import { SolarVariant } from './SolarIcon/constants';
import AsyncSolarIconLineDuotone from './SolarIcon/line-duotone/SolarIconLineDuotone.async';
import AsyncSolarIconLinear from './SolarIcon/linear/SolarIconLinear.async';
import AsyncSolarIconOutline from './SolarIcon/outline/SolarIconOutline.async';

export { LucideType } from './LucideIcon/type';
export { MaterialType, MaterialVariant } from './MaterialIcon/constants';
export { RemixType } from './RemixIcon/type';

export const MarkdownIconRegisterMap = {
  [MaterialVariant.Filled]: AsyncMaterialIconFilled,
  [MaterialVariant.Outline]: AsyncMaterialIconOutlined,
  [MaterialVariant.Rounded]: AsyncMaterialIconRounded,
  [MaterialVariant.Sharp]: AsyncMaterialIconSharp,
  [MaterialVariant['Two Tone']]: AsyncMaterialIconTwoTone,
  [PhosphorVariant.bold]: AsyncPhosphorIconBold,
  [PhosphorVariant.fill]: AsyncPhosphorIconFill,
  [PhosphorVariant.light]: AsyncPhosphorIconLight,
  [PhosphorVariant.regular]: AsyncPhosphorIconRegular,
  [PhosphorVariant.thin]: AsyncPhosphorIconThin,
  [PhosphorVariant.duotone]: AsyncPhosphorIconDuotone,
  [SolarVariant.bold]: AsyncSolarIconBold,
  [SolarVariant.broken]: AsyncSolarIconBroken,
  [SolarVariant.linear]: AsyncSolarIconLinear,
  [SolarVariant.outline]: AsyncSolarIconOutline,
  [SolarVariant['bold-duotone']]: AsyncSolarIconBoldDuotone,
  [SolarVariant['line-duotone']]: AsyncSolarIconLineDuotone,
  [LucideType]: AsyncLucideIcon,
  [RemixType]: AsyncRemixIcon,
} as const;

// export const MarkdownIconCategoryType = [MaterialType, RemixType, LucideType] as const;
